const CLIENT_CACHE_KEY = 'client_cache';
// Session-based cache: no expiration, cleared only on logout or browser close

class ClientCache {
  constructor() {
    this.cache = this.loadFromStorage();
  }

  loadFromStorage() {
    try {
      const stored = sessionStorage.getItem(CLIENT_CACHE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        return parsed.data || {};
      }
      return {};
    } catch (error) {
      console.error('Error loading client cache:', error);
      return {};
    }
  }

  saveToStorage() {
    try {
      const cacheData = {
        data: this.cache,
        timestamp: Date.now() // Keep timestamp for stats/debugging
      };
      sessionStorage.setItem(CLIENT_CACHE_KEY, JSON.stringify(cacheData));
    } catch (error) {
      console.error('Error saving client cache:', error);
    }
  }

  get(uuid) {
    return this.cache[uuid] || null;
  }

  getMultiple(uuids) {
    const results = {};
    const missing = [];
    
    uuids.forEach(uuid => {
      if (this.cache[uuid]) {
        results[uuid] = this.cache[uuid];
      } else {
        missing.push(uuid);
      }
    });
    
    return { found: results, missing };
  }

  set(uuid, clientData) {
    // Store only essential fields to reduce memory usage
    this.cache[uuid] = {
      uuid: clientData.uuid,
      name: clientData.name,
      code: clientData.code,
      id: clientData.id
    };
    this.saveToStorage();
  }

  setMultiple(clients) {
    clients.forEach(client => {
      // Store only essential fields to reduce memory usage
      this.cache[client.uuid] = {
        uuid: client.uuid,
        name: client.name,
        code: client.code,
        id: client.id
      };
    });
    this.saveToStorage();
  }

  clear() {
    this.cache = {};
    sessionStorage.removeItem(CLIENT_CACHE_KEY);
  }

  isExpired() {
    // Session-based cache never expires - only cleared on logout or browser close
    return false;
  }

  getCacheStats() {
    const count = Object.keys(this.cache).length;
    const stored = sessionStorage.getItem(CLIENT_CACHE_KEY);
    let age = 0;
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        age = Date.now() - parsed.timestamp;
      } catch (error) {
        // ignore
      }
    }
    return { count, age, expired: false };
  }
}

// Create singleton instance
const clientCache = new ClientCache();

export default clientCache;